"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTimeout = _interopRequireDefault(require("react-timeout"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Modal = ({
  isOpen,
  className,
  setTimeout,
  ...otherProps
}) => {
  const [modalOpen, setModalOpen] = (0, _react.useState)(undefined);
  const [modalClosing, setModalClosing] = (0, _react.useState)(false);
  const [backgroundVisible, setBackgroundVisible] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setModalOpen(!!isOpen);
  }, []);
  (0, _react.useEffect)(() => {
    if (modalOpen !== undefined) {
      if (isOpen) {
        setModalOpen(true);
        setModalClosing(false);
        setBackgroundVisible(false);
        setTimeout(() => {
          setBackgroundVisible(true);
        }, 50);
      } else {
        setModalClosing(true);
        setTimeout(() => {
          setBackgroundVisible(false);
        }, 250);
        setTimeout(() => {
          setModalClosing(false);
          setModalOpen(false);
        }, 650);
      }
    }
  }, [isOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledModal, {
    isOpen: modalOpen,
    closing: modalClosing,
    backgroundProps: {
      backgroundVisible
    },
    className: `rui-modal ${className}`.trim(),
    ...otherProps
  });
};

Modal.propTypes = {
  setTimeout: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired,
  isOpen: _propTypes.default.bool
};
Modal.defaultProps = {
  isOpen: false
};

var _default = (0, _reactTimeout.default)(Modal);

exports.default = _default;